"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var card_1 = require("./schema/card");
var prosemirror_model_1 = require("prosemirror-model");
var const_1 = require("./const");
var schema_1 = require("./schema/schema");
var util_1 = require("./libs/util");
/**
 * get & setHTML相关
 */
// 在 setHTML 中检查 html 最后一行是否有空的标签
exports.insertEmptyPTagAtTheEndOfHtml = function (div) {
    var lastChild = div.lastChild;
    if (!lastChild)
        return;
    if (lastChild.nodeName.toLocaleLowerCase() !== 'p' || lastChild.innerHTML !== '') {
        var blankP = document.createElement('p');
        div.appendChild(blankP);
        return;
    }
};
// 移除最后的br标签，直接操作Node会导致size不正确，需要手动修正
var removeBrInEnd = function (doc) {
    var matchNodes = [];
    var topNode;
    var topPos = 0;
    doc.content.nodesBetween(0, doc.content.size, function (node, pos, _parent, index) {
        // 新的顶层节点
        if (!_parent) {
            topNode = node;
            topPos = pos;
        }
        if (node.isTextblock && node.lastChild && node.lastChild.type === node.type.schema.nodes.break) {
            var parent_1 = _parent || doc;
            var newNode = node.copy(node.content.cut(0, node.content.size - 1));
            // 反向避免修改后位置不对
            matchNodes.unshift({ parent: parent_1, topNode: topNode, topPos: topPos, newNode: newNode, pos: pos, index: index });
            return false;
        }
    });
    matchNodes.forEach(function (_a) {
        var parent = _a.parent, _topNode = _a.topNode, _topPos = _a.topPos, newNode = _a.newNode, pos = _a.pos, index = _a.index;
        var $pos = _topNode.resolve(pos - _topPos); // border
        parent.content = parent.content.replaceChild(index, newNode);
        parent !== doc && doc.content.size--;
        var depth = $pos.depth - 2;
        while (depth >= 0) {
            $pos.node(depth).content.size--;
            depth--;
        }
    });
    return doc;
};
exports.removeBrInEnd = removeBrInEnd;
// getHTML 去掉末尾的空行
var removeEmptyTagAtEndOfHtml = function (div) {
    var MARK = '<br>';
    var lastChild;
    do {
        lastChild = div.lastChild;
        if (!lastChild || lastChild.innerHTML !== MARK)
            break;
        lastChild.parentElement && lastChild.parentElement.removeChild(lastChild);
    } while (lastChild.innerHTML === MARK);
};
var IG_TAG = 'ignoretag';
exports.IG_TAG = IG_TAG;
var IG_EL = 'ignoreel';
exports.IG_EL = IG_EL;
// 移除tag
var removeTag = function (el) {
    if (el.parentNode) {
        Array.from(el.childNodes).forEach(function (cNode) { return el.parentNode.insertBefore(cNode, el); });
        el.parentNode.removeChild(el);
    }
};
var removeIgnoreTag = function (div) {
    var ignoreTags = div.querySelectorAll("*[" + IG_TAG + "=true], .ProseMirror-separator");
    Array.from(ignoreTags)
        .reverse()
        .forEach(removeTag);
};
// 移除dom
var removeIgnoreContent = function (div) {
    var ignoreEls = div.querySelectorAll("*[" + IG_EL + "=true]");
    Array.from(ignoreEls)
        .reverse()
        .forEach(function (el) {
        el.parentElement.removeChild(el);
    });
};
// inlineCard在最后一个元素是br时去除br
var removeBrAfterInlineCard = function (div) {
    Array.from(div.querySelectorAll('.ProseMirror-trailingBreak')).forEach(function (node) { return node.removeAttribute('class'); });
    Array.from(div.querySelectorAll('syl-inline')).forEach(function (a) {
        if (a.nextElementSibling &&
            a.parentElement &&
            a.parentElement.lastChild === a.nextElementSibling &&
            a.nextElementSibling.tagName === 'BR' &&
            a.nextElementSibling.parentElement) {
            a.parentElement.removeChild(a.nextElementSibling);
        }
    });
};
// 合并连续的<br>,<p><br></p>
var mergeContinuesEmptyLine = function (node) {
    var domRemoves = [];
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_ALL, {
        acceptNode: function (cNode) {
            if (cNode.nodeType === 1 || cNode.nodeType === 3) {
                return NodeFilter.FILTER_ACCEPT;
            }
            return NodeFilter.FILTER_REJECT;
        }
    });
    var prevTag = '';
    var isEmptyParagraph = function (p) { return p && p.nodeName === 'P' && /^<br>+$/.test(p.innerHTML); };
    var judgeMerge = function (judgeNode) {
        var res = false;
        if (judgeNode.nodeName === 'BR' && prevTag === 'BR') {
            res = true;
        }
        else if (judgeNode.nodeType === 1 &&
            isEmptyParagraph(judgeNode) &&
            isEmptyParagraph(judgeNode.previousElementSibling)) {
            res = true;
        }
        prevTag = judgeNode.nodeName;
        return res;
    };
    while (walker.nextNode()) {
        var curNode = walker.currentNode;
        if (judgeMerge(curNode)) {
            domRemoves.push(curNode);
        }
    }
    domRemoves.forEach(function (dom) { return dom.parentNode && dom.parentNode.removeChild(dom); });
};
// 用<templ>内部内容替换<syl>
var removeShell = function (root) {
    var cards = root.querySelectorAll("[" + card_1.SYL_TAG + "]");
    [].slice.call(cards).forEach(function (card) {
        card.childNodes.forEach(function (child) {
            if (child.tagName === 'TEMPL' && card.parentElement) {
                card.parentElement.replaceChild(child, card);
                removeTag(child);
            }
        });
    });
    return root.innerHTML;
};
var transformGetHTML = function (html, sylPlugins) {
    var res = html;
    sylPlugins.forEach(function (_a) {
        var $controller = _a.$controller;
        if ($controller && $controller.transformGetHTML) {
            res = $controller.transformGetHTML(res);
        }
    });
    return res;
};
var handleDOMSpec = function (dom) {
    removeIgnoreTag(dom);
    removeIgnoreContent(dom);
    return dom;
};
exports.handleDOMSpec = handleDOMSpec;
var formatGetHTML = function (root, config, sylPlugins) {
    var div = util_1.Utils.createDetachedElement('div');
    var salt = String(Math.random()).substring(2, 8);
    div.hidden = true;
    div.innerHTML = root.innerHTML.replace(/(<[^>]*)(src=)/g, "$1data" + salt + "src=");
    handleDOMSpec(div);
    removeBrAfterInlineCard(div);
    config && config.mergeEmpty && mergeContinuesEmptyLine(div);
    removeEmptyTagAtEndOfHtml(div);
    var pureHTML = function (html) { return html.replace(new RegExp("data" + salt + "src=", 'g'), 'src='); };
    var resHTML = pureHTML(removeShell(div));
    return transformGetHTML(resHTML, sylPlugins);
};
exports.formatGetHTML = formatGetHTML;
var formatSetHTML = function (html, config) {
    var div = util_1.Utils.createDetachedElement('div');
    div.innerHTML = html;
    // this replace break element with \n in codeblock
    handleDOMSpec(div);
    // fixme 为了修复 setHTML 之后，点击编辑器，导致触发 text-change 事件，在末尾加入一个空的 p 标签
    config.keepLastLine && exports.insertEmptyPTagAtTheEndOfHtml(div);
    config.mergeEmpty && mergeContinuesEmptyLine(div);
    return div;
};
exports.formatSetHTML = formatSetHTML;
var getSplicedNode = function (node, start, end, newNode) {
    var plus = 0;
    var originText = node.text;
    var prevText = originText.substring(0, start);
    var nextText = originText.substring(end);
    var nodes = [];
    if (prevText) {
        nodes.push(__assign(__assign({}, node), { text: prevText }));
        plus++;
    }
    nodes.push(newNode);
    nextText && nodes.push(__assign(__assign({}, node), { text: nextText }));
    return { nodes: nodes, plus: plus };
};
var getMatchRules = function (sylPlugins) {
    var inlineMatchers = [];
    var blockMatchers = [];
    sylPlugins.forEach(function (_a) {
        var $schemaMeta = _a.$schemaMeta;
        if ($schemaMeta && $schemaMeta.config.textMatcher) {
            if ($schemaMeta.formatType === schema_1.FORMAT_TYPE.INLINE_CARD) {
                $schemaMeta.config.textMatcher
                    .filter(function (r) { return r.inputOnly === false; })
                    .forEach(function (r) {
                    inlineMatchers.push({ name: $schemaMeta.name, matchRule: r });
                });
            }
            else if ($schemaMeta.formatType === schema_1.FORMAT_TYPE.BLOCK_CARD) {
                $schemaMeta.config.textMatcher
                    .filter(function (r) { return r.inputOnly !== true; })
                    .forEach(function (r) {
                    blockMatchers.push({ name: $schemaMeta.name, matchRule: r });
                });
            }
        }
    });
    var matchNode = function (node, type) {
        if (type === void 0) { type = 'block'; }
        var curMatchRules = type === 'block' ? blockMatchers : inlineMatchers;
        for (var i = 0; i < curMatchRules.length; i++) {
            var _a = curMatchRules[i].matchRule, matcher = _a.matcher, handler = _a.handler;
            var newMatchers = new RegExp(matcher.source, matcher.flags);
            var matched = newMatchers.exec(node.text);
            if (!matched)
                continue;
            var attrs = handler(matched);
            if (!attrs)
                continue;
            return {
                node: {
                    type: curMatchRules[i].name,
                    marks: node.marks,
                    attrs: attrs
                },
                matchInfo: {
                    start: matched.index,
                    end: matched.index + matched[0].length
                }
            };
        }
    };
    return { matchNode: matchNode, blockMatchers: blockMatchers, inlineMatchers: inlineMatchers };
};
// 特殊的 HTML 通过 textMatch 转化为结构化数据
var transformCard = function (docNode, view, sylPlugins) {
    var doc = docNode.toJSON();
    var _a = getMatchRules(sylPlugins), matchNode = _a.matchNode, blockMatchers = _a.blockMatchers, inlineMatchers = _a.inlineMatchers;
    doc = {
        type: 'doc',
        content: doc.content.map(function (node) {
            if (blockMatchers.length &&
                node.type === const_1.NODE_NAME.P &&
                node.content &&
                node.content.length === 1 &&
                node.content[0].type === 'text') {
                var res = matchNode(node.content[0]);
                if (res)
                    return res.node;
            }
            if (inlineMatchers.length && node.content) {
                var loopContent_1 = function (_content) {
                    for (var i = 0; i < _content.length; i++) {
                        var curNode = _content[i];
                        if (curNode && curNode.content) {
                            loopContent_1(curNode.content);
                        }
                        else if (curNode.text) {
                            var res = matchNode(curNode, 'inline');
                            if (res) {
                                var spliceNodeInfo = getSplicedNode(curNode, res.matchInfo.start, res.matchInfo.end, res.node);
                                _content.splice.apply(_content, __spreadArrays([i, 1], spliceNodeInfo.nodes));
                                i += spliceNodeInfo.plus;
                            }
                        }
                    }
                };
                loopContent_1(node.content);
            }
            return node;
        })
    };
    return prosemirror_model_1.Node.fromJSON(view.state.schema, doc);
};
exports.transformCard = transformCard;
var parseHTML = function (html, editor, config) {
    var _a = editor.configurator.configuration, view = _a.view, basicConfiguration = _a.basicConfiguration;
    var htmlNode = formatSetHTML(html, __assign(__assign({}, basicConfiguration), config));
    var docNode = transformCard(
    // TODO：统一用parseSlice
    editor.domParser.parse(htmlNode, {
        preserveWhitespace: config.keepWhiteSpace || basicConfiguration.keepWhiteSpace
    }), view, editor.configurator.getSylPlugins());
    removeBrInEnd(docNode);
    return docNode;
};
exports.parseHTML = parseHTML;
//# sourceMappingURL=formatter.js.map